export const PRODUCT_TYPES = {
  VOD_COURSE: {
    class: "vod",
    tag: "VOD"
  },
  REAL_TIME_LECTURE: {
    class: "one-one",
    tag: "1:1"
  },
  EVENT: {
    class: "event",
    tag: "Event"
  },
  PACKAGE: {
    class: "package",
    tag: "Package"
  },
  VOD_SERIES: {
    class: "vod-series",
    tag: "VOD series"
  }
  ,
  CLASS: {
    class: "class",
    tag: "Course"
  },
  DOTORE_PASS: {
    class: "dotore-pass",
    tag: "Pass"
  }
};

export const PRODUCT_TYPE_CODES = {
  VOD_COURSE: "VOD_COURSE",
  REAL_TIME_LECTURE: "REAL_TIME_LECTURE",
  EVENT: "EVENT",
  PACKAGE: "PACKAGE",
  VOD_SERIES: "VOD_SERIES",
  CLASS: "CLASS",
  DOTORE_PASS: "DOTORE_PASS"
};

